export default __webpack_public_path__ + "static/media/six.236f13e9.svg";